define(["./nlgPasswordModule"], function (nlgPasswordModule) {
    "use strict";

    var PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!]).{8,}$/;

    return nlgPasswordModule.service("nlgPasswordService", [
        function () {

            return {
                isValidPassword: isValidPassword
            };

            function isValidPassword(password) {
                return PASSWORD_REGEX.test(password);
            }
        }]);
});